import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { AddToWatchlistIcon } from '@sorare/core/src/atoms/icons/AddToWatchlistIcon';

import { AddToWatchlistButton } from '#src/components/watchlists/AddToWatchlistButton/index.tsx';
import { ManagePlayerInWatchlist } from '#src/components/watchlists/ManagePlayerInWatchlist/index.tsx';

import type { SearchPlayerCellActions_anyPlayer } from './__generated__/index.graphql.ts';

type Props = {
  anyPlayer: SearchPlayerCellActions_anyPlayer;
  watchlistId?: string;
  favoritesWatchlist?: boolean;
};

export const SearchPlayerCellActions = ({
  anyPlayer,
  watchlistId,
  favoritesWatchlist,
}: Props) => {
  if (watchlistId || favoritesWatchlist) {
    return (
      <ManagePlayerInWatchlist
        anyPlayer={anyPlayer}
        watchlistId={watchlistId}
        size="medium"
        color="quaternary"
      />
    );
  }
  return (
    <AddToWatchlistButton
      anyPlayer={anyPlayer}
      size="medium"
      color="quaternary"
      ctaLabel={<AddToWatchlistIcon />}
    />
  );
};

SearchPlayerCellActions.fragments = {
  anyPlayer: gql`
    fragment SearchPlayerCellActions_anyPlayer on AnyPlayerInterface {
      slug
      ...AddToWatchlistButton_anyPlayer
      ...ManagePlayerInWatchlist_anyPlayer
    }
    ${AddToWatchlistButton.fragments.anyPlayer}
    ${ManagePlayerInWatchlist.fragments.anyPlayer}
  ` as TypedDocumentNode<SearchPlayerCellActions_anyPlayer>,
};
